import React from "react";
import { Button } from "semantic-ui-react";
import './ButtonComponent.scss';
export type ButtonComponentProps = {
    onBtnClick: Function;
    label: string | React.ReactNode;
    theme?: string; // primaryBtn secondaryBtn tertiary
    loading?: boolean;
    disabled?: boolean;
    btnHeight?: string; // decides if its shorter than default
    tooltip?: string;
}

export const ButtonComponent = (props: ButtonComponentProps) => {

    return (
        <div className="button-component">
            <Button
                className={`${props.btnHeight ? "btnHeightSlim" : ""} ${props.theme}`}
                disabled={props.disabled === true}
                loading={props.loading === true}
                onClick={(e) => props.onBtnClick(e)}
                data-tooltip={props.tooltip ? props.tooltip : null}
                data-position="top left"
                data-inverted=""
            >
                {props.label}
            </Button>
        </div>
    )
}
